import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AlreadySignedInGuard } from './auth/guards/already-signed-in.guard';

import { SignInComponent } from './auth/components/sign-in/sign-in.component';
import { SignUpComponent } from './auth/components/sign-up/sign-up.component';
import { ResetPasswordComponent } from './auth/components/reset-password/reset-password.component';

const routes: Routes = [
  { path: 'sign-in', component: SignInComponent, canActivate: [AlreadySignedInGuard] },
  { path: 'sign-up', component: SignUpComponent, canActivate: [AlreadySignedInGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [AlreadySignedInGuard] },

  { path: '', loadChildren: './dashboard/dashboard.module#DashboardModule' },

  { path: '**', redirectTo: '/sign-in' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
